import { Link } from "@heroui/react";
import { SiLemmy } from "@icons-pack/react-simple-icons";

import { Button } from "../../core/Button";

export const LemmyButton = () => {
  return (
    <Button
      as={Link}
      size="sm"
      href="https://toast.ooo/c/canvas"
      target="_blank"
      variant="ghost"
    >
      <SiLemmy size={18} />
      <p>Lemmy</p>
    </Button>
  );
};
